import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useDecodedToken from "../../../hooks/userHooks/useDecodedToken";
import useFetchOtherUserInfos from "../../../hooks/userHooks/useFetchOtherUserInfos";
import { changeCurrentUserWithFeeds } from "../../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../../redux/store";
import CurrentUserProfilePage from "./CurrentUserProfilePage";
import OtherUserProfilePage from "./OtherUserProfilePage";

type Props = {
  username: string;
};

function ProfileWrapper({ username }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const collectionTab = searchParams.get("ctc");
  const { connectedUsername, role, sourceId } = useDecodedToken();
  const { otherUser: user, error } = useFetchOtherUserInfos(username);
  const fromPayment = sessionStorage.getItem("payment-page") === "True";
  const dispatch = useDispatch<AppDispatch>();
  const { currentUserWithFeeds } = useSelector((state: StoreState) => state.feeds);

  useEffect(() => {
    if (user?.id && user.id !== currentUserWithFeeds) {
      dispatch(changeCurrentUserWithFeeds(user?.id));
    }
  }, [user?.id]);
  const handleNavigate = () => {
    localStorage.removeItem("activeProfileTab");
    if (fromPayment) {
      navigate("/common/discover");
      sessionStorage.removeItem("payment-page");
    } else if (collectionTab) {
      navigate(-3);
    } else {
      navigate(-1);
    }
  };

  //TODO: Oussama loader ??
  // if (!user?.id) {
  //   return (
  //     <div style={{ height: "100dvh", display: "flex", alignItems: "center", justifyContent: "center" }}>
  //       <></>;
  //     </div>
  //   );
  // }

  if (connectedUsername === username) {
    return <CurrentUserProfilePage />;
  } else {
    return <OtherUserProfilePage username={username} handleNavigate={handleNavigate} currentUserRole={role} currentUserId={sourceId} />;
  }
}

export default ProfileWrapper;
